// const breakPoints = {
//   sm: { name: 'Small', id: 'sm', icon: '<span class="icon-mobile-phone"></span>', min: 0, max: 640 },
//   md: { name: 'Medium', id: 'md', icon: '<span class="icon-tablet"></span>', min: 641, max: 768 },
//   lg: { name: 'Large', id: 'lg', icon: '<span class="icon-laptop"></span>', min: 769, max: 1024 },
//   xl: { name: 'Extra-Large', id: 'xl', icon: '<span class="icon-desktop"></span>', min: 1025, max: 1280 },
//   xl2: { name: '2 Extra-Large', id: 'xl2', icon: '<span class="icon-television"></span>', min: 1281, max: 1536 }
// };


const breakPoints = {
  Mobile: { name: 'Mobile', id: 'Mobile', icon: '<span class="icon-mobile-phone"></span>', min: 0, max: 767 },
  Tablet: { name: 'Tablet', id: 'Tablet', icon: '<span class="icon-tablet"></span>', min: 768, max: 991 },
  Desktop: { name: 'Desktop', id: 'Desktop', icon: '<span class="icon-desktop"></span>', min: 992, max: 1280 },

};


export default breakPoints;